import { render, staticRenderFns } from "./FullNameCell.vue?vue&type=template&id=95863534&"
import script from "./FullNameCell.vue?vue&type=script&lang=js&"
export * from "./FullNameCell.vue?vue&type=script&lang=js&"
import style0 from "./FullNameCell.vue?vue&type=style&index=0&id=95863534&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports